import { createSelector } from 'reselect';
import { selectors as macheteReduxSelectors } from 'src/machete-redux';
import appDux from 'src/redux/app';
import utils from 'src/utils';
import constants from 'src/constants';
import featureFlags from 'src/featureFlags';
import { getViewer } from 'src/machete-redux';

const { MODE_NAMES } = constants.app;

const getLabels = (state) => state.designPro.machete.labels;
const getManufacturerProducts = (state) =>
  state.designPro.machete.manufacturerProducts;
const getManufacturers = (state) => state.designPro.machete.manufacturers;
const getMaterialByIdProp = (state, { materialId }) =>
  state.designPro.machete.labels[materialId];
const getProducts = (state) => state.designPro.machete.products;
const getHyperionModelData = (state) =>
  state.designPro.machete.hyperionModelData;

const getManufacturerByIdProp = (state, { brandId }) =>
  state.designPro.machete.manufacturers[brandId];

/**
 * Below is the original getVisibleNodes, it has been replaced with a function
 * that calls either this one below or uses another selector depending whether
 * the feature flag is on or off. Will be removed after Sliding Glass Door
 * goes live
 */
// eslint-disable-next-line camelcase
const getVisibleNodes_featureFlagOff = createSelector(
  macheteReduxSelectors.segmentation.getNodes,
  (nodes) =>
    Object.values(nodes)
      .filter(utils.machete.nodeIsVisible)
      .filter(utils.machete.nodeHasValidPrimaryLabelId),
);

const getVisibleNodes = (state) =>
  featureFlags.shouldUseMacheteFeatureAPI()
    ? appDux.selectors.getNodeStyles(state)
    : getVisibleNodes_featureFlagOff(state);

const getVisibleNodeIdSet = createSelector(
  getVisibleNodes,
  (visibleNodes) => new Set(visibleNodes.map(({ uuid }) => uuid)),
);

const getSelectedElementCount = createSelector(
  macheteReduxSelectors.segmentation.getSelectedNodeIds,
  (selectedNodeIds) => selectedNodeIds.length,
);

const shouldAllowUpdateSelection = ({ designPro }) =>
  designPro.app.activeMode === MODE_NAMES.DESIGN &&
  !designPro.split.isSplitToolActive &&
  !designPro.ui.isJobShareModalOpen;

const getMeasureTool = (state) => {
  if (!state.designPro.machete.measureTool) {
    const viewer = getViewer();
    const helperLayer = viewer.layers.get('helperLayer');
    const measureTool = new Hover.Machete.MeasureTool(viewer, helperLayer, {
      minSegmentLength: 0.01,
    });
    let originalCursor;
    measureTool.addEventListener('enabled', () => {
      originalCursor = document.body.style.cursor;
      document.body.style.cursor = 'crosshair';
    });
    measureTool.addEventListener('disabled', () => {
      document.body.style.cursor = originalCursor;
    });
    state.designPro.machete.measureTool = measureTool;
  }
  return state.designPro.machete.measureTool;
};

export default {
  getHyperionModelData,
  getLabels,
  getManufacturerByIdProp,
  getManufacturerProducts,
  getManufacturers,
  getMaterialByIdProp,
  getMeasureTool,
  getProducts,
  getSelectedElementCount,
  getVisibleNodeIdSet,
  getVisibleNodes,
  shouldAllowUpdateSelection,
};
